import script from "./Watermarks.vue?vue&type=script&setup=true&lang=ts"
export * from "./Watermarks.vue?vue&type=script&setup=true&lang=ts"

import "./Watermarks.scss?vue&type=style&index=0&id=3936e8be&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3936e8be"]])

export default __exports__